import React,{useState} from 'react'

const BranchSearch = ({varSearchData,setSearchData,setPageNum}) => {
  //항목별 검색변수값 설정
  const [varSearchOption, setSearchOption] = useState(varSearchData.searchOption);
  const [varSearchString, setSearchString] = useState(varSearchData.searchString);

  //검색항목 선택값 저장
  const onSearchOptionHandler = (e) => {   
    setSearchOption(e.currentTarget.value);
  }

  //검색문자 저장
  const onSearchStringHandler = (e) => {   
    setSearchString(e.currentTarget.value);
  }

  //검색시작
  const onExecuteSearchingHandler = (e) => {
    e.preventDefault();
    setSearchData({searchOption:varSearchOption,searchString:varSearchString});
    setPageNum(1);
  }

  //검색정보 초기화
  const onClearSearchHandler = (e) => {
    e.preventDefault();
    setSearchData({searchOption:"all",searchString:""});
    setPageNum(1);
    setSearchOption("all");
    setSearchString("");
  }

  return (
    <div className="main-box" style={{height:"60px"}}>
      <div className="search-area" style={{position:"relative"}}>
        <div className="search-string" style={{position:"absolute",right:"0px"}}>
          <select value={varSearchOption} style={{width:"150px"}} onChange={(e)=>onSearchOptionHandler(e)}>
              <option value={"all"}>전체</option>
              <option value={"bh_code"}>센터코드</option>
              <option value={"bh_company"}>센터명</option>
              <option value={"bh_name"}>대표자명</option>
              <option value={"bh_id"}>계정</option>
          </select>
          <input type="text" value={varSearchString} onChange={(e)=>onSearchStringHandler(e)} placeholder="검색어를 입력해주세요"/>
          <button onClick={(e)=>onExecuteSearchingHandler(e)} className="btn">조회</button>
          <button onClick={(e)=>onClearSearchHandler(e)} className="btn black">초기화</button>
        </div>
      </div>
    </div>
  )
}
export default BranchSearch;